import {copyLineAtIndex, deleteLineAtIndex, newBlankLine,} from '@/transaction/create-transaction/TransactionCreator.service'
import {CrTransGridElement, focusGridElement, getColumnIndexFromColumnId} from '@/transaction/create-transaction/focusHelper'

const keysMapping = {
    newBlankLine: {
        firefox: ['?'],
        chrome: ['+']
    },
    copyLine: {
        firefox: ['*', ':'],
        chrome: ['*', '.']
    },
    deleteLine: {
        firefox: ['-'],
        chrome: ['_', '−']
    },
}

const matchesKey = (key: string, command: keyof typeof keysMapping) => {
    return Object.values(keysMapping[command]).flat().includes(key)
}

const handleKeydown = (ev: KeyboardEvent, {rowIndex, columnIndex}: CrTransGridElement) => {
    if (ev.key === 'ArrowUp') {
        focusGridElement(rowIndex - 1, columnIndex)
    }
    if (ev.key === 'ArrowDown') {
        focusGridElement(rowIndex + 1, columnIndex)
    }
    if (ev.key === 'ArrowLeft') {
        focusGridElement(rowIndex, columnIndex - 1, 'left')
    }
    if (ev.key === 'ArrowRight') {
        focusGridElement(rowIndex, columnIndex + 1)
    }
    if (matchesKey(ev.key, 'newBlankLine')) {
        newBlankLine(rowIndex + 1)
        const debitColIndex = getColumnIndexFromColumnId('DEBIT')

        focusGridElement(rowIndex + 1, debitColIndex ?? columnIndex)
    }
    if (matchesKey(ev.key, 'copyLine')) {
        copyLineAtIndex(rowIndex)
        focusGridElement(rowIndex + 1, columnIndex)
    }
    if (matchesKey(ev.key, 'deleteLine')) {
        deleteLineAtIndex(rowIndex)
        focusGridElement(rowIndex - 1, columnIndex)
    }
}

export {
    handleKeydown
}